import React from "react"
import PropTypes from "prop-types"
import FontAwesome from "react-fontawesome"
import moment from "moment"
import "./LastLocation.scss"

const LastLocation = ({ location, notDetected, timeSinceDetected }) => {
  const dateFormatter = date => {
    const hourPortion = date.format("hh:mm a")
    const datePortion = date.format("MMM Do YYYY")
    return hourPortion.slice(0, -1).concat(" ", datePortion)
  }
  return (
    <div className="last-location">
      <div className="last-location-block">
        <FontAwesome className="last-seen-icon" name={"clock-o"} />
        <div className="last-location-info">
          <span className="last-location-header-text">LAST PING</span>
          <span className="last-location-body-text">
            {notDetected
              ? `Asset tagged, not yet detected.`
              : `${dateFormatter(
                  moment().subtract(timeSinceDetected, "milliseconds")
                )}`}
          </span>
        </div>
      </div>
      <div className="last-location-block">
        <FontAwesome className="last-location-icon" name={"map-marker"} />
        <div className="last-location-info">
          <span className="last-location-header-text">LAST LOCATION</span>
          <span className="last-location-body-text">
            {notDetected
              ? `Last location not available.`
              : `${location.name}, ${location.unit.name}`}
          </span>
        </div>
      </div>
    </div>
  )
}

LastLocation.propTypes = {
  location: PropTypes.shape({
    name: PropTypes.string,
    unit: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  notDetected: PropTypes.bool,
  timeSinceDetected: PropTypes.number,
}

export default LastLocation
